<uilab-mat-sidenav-container>
  <uilab-mat-sidenav
    #sidenav
    fixedInViewport="true"
    [fixedTopGap]="gap"
    mode="over"
    position="end"
    class="noscroll"
    >
    <section class="uilabContainer">
      <header class="uilabContainer--header">
        <div class="uilabContainer--header__identity">
          <img
            [src]="selectedIconPreview"
            class="uilabContainer--header__icon"
            alt="preview"
            />
          <h6>{{
            selectedIcon.name != '' ? selectedIcon.name : '---'
          }}</h6>
        </div>
        <uilab-icon-button (click)="sidenav.close()">
          <uilab-icon slot="icon" icon="action--close"></uilab-icon>
        </uilab-icon-button>
      </header>

      <section class="uilabContainer--content">
        <app-appicon-details
          [icon]="selectedIcon"
        ></app-appicon-details>
      </section>
    </section>
  </uilab-mat-sidenav>

  <uilab-mat-sidenav-content class="content">
    <div class="iconGallery--header">
      <div class="iconGallery--count">{{ icons.length }} icons shown</div>
      <div class="iconGallery--version">
        Version {{ appIconService.version }}
      </div>
    </div>

    <div>
      <div class="icons-content">
        <app-appicon-filter
          [args]="filterArgs"
          (onFilterChange)="FilterChange()"
        ></app-appicon-filter>

        @if (galleryReady) {
          @if (!error) {
            <div>
              @for (i of icons; track i) {
                <div>
                  <p
                    class="iconGallery--icon"
                    (click)="select(i)"
                    >
                    <img
                      [src]="i.displayImgUrl"
                      class="iconGallery--img"
                      alt="icon"
                      />
                    <span class="iconGallery--icon-label">{{
                      i.name
                    }}</span>
                  </p>
                </div>
              }
            </div>
          } @else {
            <app-error [error]="errorMsg"></app-error>
          }
        } @else {
          <app-appicon-gallery-blockframe></app-appicon-gallery-blockframe>
        }
      </div>
      <div class="uilabContainer--footer"></div>
    </div>
  </uilab-mat-sidenav-content>
</uilab-mat-sidenav-container>
